import { render, staticRenderFns } from "./boq-create-link-modal.vue?vue&type=template&id=56f13f66"
import script from "./boq-create-link-modal.vue?vue&type=script&lang=js"
export * from "./boq-create-link-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports